/* eslint-disable object-property-newline */
import { Config } from '@leverege/plugin';
import { ValuesCache } from '@leverege/value-cache';
import MoltenUtil from "../../MoltenUtil.js";
import LayoutVersions from "./LayoutVersions.js";
const caches = new ValuesCache();
function DefaultLayoutDelegate(options, cfg) {
  const {
    client,
    clientType,
    path,
    objectType,
    activePersona,
    layoutVersions,
    customLayout,
    layoutId
  } = options;
  const {
    usePersona = true,
    useShared = true,
    useUser = true,
    useObjectType = true
  } = cfg;
  return caches.calc(`${client}:${activePersona?.name || ''}:${path || ''}:${objectType || null}`, doDefaultLayout, layoutId, client, clientType, path, objectType, activePersona, layoutVersions, customLayout, usePersona, useShared, useUser, useObjectType);
}
function doDefaultLayout(layoutId, client, clientType, path, objectType, activePersona, layoutVersions, customLayout, usePersona, useShared, useUser, useObjectType) {
  let id,
    lv,
    pKey = null;
  const key = `${clientType}.${path}`;
  if (usePersona && activePersona && activePersona.name) {
    pKey = `p-${activePersona.name}.${key}`;
  }
  // Optionally look in local storage
  if (Config.get('UserSettingsDefaultLayoutDelegate', 'useLastViewed', false)) {
    id = window.localStorage.getItem(`${key}.lastLayoutKey`);
    lv = LayoutVersions.getLayoutFrom(layoutVersions, id);
    if (lv) {
      return lv;
    }
  }

  // Look into the preferences. User first, then persona, then shared
  if (Config.get('UserSettingsDefaultLayoutDelegate', 'usePreferred', true)) {
    if (useUser && Config.get('UserSettingsDefaultLayoutDelegate', 'allowUserPreferred', true)) {
      id = layoutVersions.find(g => g.type === 'userLayout')?.preferred;
      lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, id) : null;
      if (lv) {
        return lv;
      }
    }
    if (usePersona && activePersona && activePersona.name) {
      id = layoutVersions.find(g => g.type === 'personaLayout' && g.value === activePersona.name)?.preferred;
      lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, id) : null;
      if (lv) {
        return lv;
      }
    }
    if (useShared) {
      id = layoutVersions.find(g => g.type === 'sharedLayout')?.preferred;
      lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, id) : null;
      if (lv) {
        return lv;
      }
      if (useObjectType) {
        id = layoutVersions.find(g => g.type === 'objectTypeLayout' && g.value === objectType)?.preferred;
        lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, id) : null;
        if (lv) {
          return lv;
        }
      }
    }
  }
  // Use Config - Persona + Path config
  id = pKey && Config.get('UserSettingsDefaultLayoutDelegate', `${pKey}.defaultLayout`, null);
  lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, `p-${activePersona.name}:${id}`) : null;
  if (lv) {
    return lv;
  }

  // Use Config - Path Config
  id = Config.get('UserSettingsDefaultLayoutDelegate', `${key}.defaultLayout`, null);
  lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, `s:${id}`) : null;
  if (lv) {
    return lv;
  }

  // Use Config - ObjectType Config
  id = Config.get('UserSettingsDefaultLayoutDelegate', `${objectType}.defaultLayout`, null);
  lv = typeof id === 'string' ? LayoutVersions.getLayoutFrom(layoutVersions, `s:${id}`) : null;
  if (lv) {
    return lv;
  }
  // Did the user already change one and save to the settings?
  if (customLayout) {
    return {
      layout: customLayout,
      layoutId: 'none'
    };
  }

  // try first of any defined
  // try default model
  const creators = MoltenUtil.sortedPlugins('DefaultLayoutModelCreator');
  const options = {
    path,
    client,
    clientType,
    activePersona,
    objectType,
    layoutVersions,
    usePersona,
    useShared,
    useUser,
    useObjectType,
    layoutId
  };
  for (let n = 0; n < creators.length; n++) {
    const layout = creators[n].create(options);
    if (layout != null) {
      return {
        layoutVersions,
        layout
      };
    }
  }
  // Out of options. return null
  return null;
}
export default DefaultLayoutDelegate;